module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/bz-cro-landing-pages/node_modules/gatsby-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":800,"linkImagesToOriginal":false}}]},
    },{
      plugin: require('/var/lib/jenkins/workspace/bz-cro-landing-pages/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/lib/jenkins/workspace/bz-cro-landing-pages/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/var/lib/jenkins/workspace/bz-cro-landing-pages/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
